
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/somit",
      function () {
        return require("private-next-pages/somit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/somit"])
      });
    }
  